import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useState } from 'react';

export default function TeacherSalaryTab() {
  const [open, setOpen] = useState(false);

  return (
    <div className="space-y-4">
      {/* Overview */}
      <Card>
        <CardHeader>
          <CardTitle>Salary Overview</CardTitle>
        </CardHeader>
        <CardContent className="grid grid-cols-2 gap-4">
          <div>
            <strong>Salary Type:</strong> Percent
          </div>
          <div>
            <strong>Base Salary:</strong> 7 000 000 so‘m
          </div>
          <div>
            <strong>Total Paid:</strong> 21 000 000 so‘m
          </div>
          <div>
            <strong>Pending:</strong> 3 500 000 so‘m
          </div>
        </CardContent>
      </Card>

      {/* Add Salary Dialog */}
      <Button onClick={() => setOpen(true)}>Oylik chiqarish</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Oylik chiqarish</DialogTitle>
          </DialogHeader>
          <div className="space-y-3">
            <div>
              <label>Davr (Oy)</label>
              <select className="w-full border rounded p-2">
                <option>Avgust 2025</option>
                <option>Iyul 2025</option>
              </select>
            </div>
            <div>
              <label>Hisoblangan summa</label>
              <input
                className="w-full border rounded p-2"
                value="3 500 000 so‘m"
                readOnly
              />
            </div>
            <div>
              <label>Bonus/chegirma</label>
              <input
                type="number"
                className="w-full border rounded p-2"
                placeholder="0"
              />
            </div>
            <Button className="w-full">Tasdiqlash</Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Salary History */}
      <Card>
        <CardHeader>
          <CardTitle>Oyliklar tarixi</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="flex justify-between border-b pb-2">
            <div>Avgust 2025</div>
            <div>3 500 000 so‘m</div>
          </div>
          <div className="flex justify-between border-b pb-2">
            <div>Iyul 2025</div>
            <div>7 000 000 so‘m</div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
